import React from "react";
import Card from "react-bootstrap/Card";
import CardDeck from "react-bootstrap/CardDeck";
import Image from "react-bootstrap/Image";

// skills
import { skills } from "./skillsDb";

import "./skills.css";

const Skills = () => {
  return (
    <div className="pt-3 pb-3" id="skills">
      <h1 className="pt-3 text-center font-details pb-2">Nuestros Colaboradores</h1>
      <CardDeck>
      <div>
          <Card className="focus mb-2">
            <Card.Body>
              <Card.Title className="text-center  card-title">
                Adriana Porras
              </Card.Title>
              <hr />
              <Card.Text className="card-text d-flex justify-content-start flex-column">
                {skills.frontend.map((skill, index) => (
                  <span key={index}>
                    <a
                      className="text-dark text-decoration-none"
                      href={skill.link}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <Image
                        src={skill.imgSrc}
                        alt={skill.imgAltText}
                        rounded
                        className="image-style m-1"
                      ></Image>{" "}
                      {skill.skillName}
                    </a>
                  </span>
                ))}
              </Card.Text>
            </Card.Body>
          </Card>
        </div>

        <div>
          <Card className="focus mb-2">
            <Card.Body>
              <Card.Title className="text-center  card-title">
                Titulo de tarjeta
              </Card.Title>
              <hr />
              <Card.Text className="card-text d-flex justify-content-start flex-column">
                {skills.frontend.map((skill, index) => (
                  <span key={index}>
                    <a
                      className="text-dark text-decoration-none"
                      href={skill.link}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <Image
                        src={skill.imgSrc}
                        alt={skill.imgAltText}
                        rounded
                        className="image-style m-1"
                      ></Image>{" "}
                      {skill.skillName}
                    </a>
                  </span>
                ))}
              </Card.Text>
            </Card.Body>
          </Card>
        </div>
        <div>
          <Card className="focus mb-2">
            <Card.Body>
              <Card.Title className="text-center  card-title">
                Titulo de tarjeta
              </Card.Title>
              <hr />
              <Card.Text className="card-text d-flex justify-content-start flex-column">
                {skills.frontend.map((skill, index) => (
                  <span key={index}>
                    <a
                      className="text-dark text-decoration-none"
                      href={skill.link}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <Image
                        src={skill.imgSrc}
                        alt={skill.imgAltText}
                        rounded
                        className="image-style m-1"
                      ></Image>{" "}
                      {skill.skillName}
                    </a>
                  </span>
                ))}
              </Card.Text>
            </Card.Body>
          </Card>
        </div>

        <div>
          <Card className="focus mb-2">
            <Card.Body>
              <Card.Title className="text-center  card-title">
                Titulo de tarjeta
              </Card.Title>
              <hr />
              <Card.Text className="card-text d-flex justify-content-start flex-column">
                {skills.frontend.map((skill, index) => (
                  <span key={index}>
                    <a
                      className="text-dark text-decoration-none"
                      href={skill.link}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <Image
                        src={skill.imgSrc}
                        alt={skill.imgAltText}
                        rounded
                        className="image-style m-1"
                      ></Image>{" "}
                      {skill.skillName}
                    </a>
                  </span>
                ))}
              </Card.Text>
            </Card.Body>
          </Card>
        </div>
      </CardDeck>
    </div>
  );
};

export default Skills;
